define('app/controllers.js',[], function() {

    var controllers = {};

    controllers.appCtrl = function($scope, $location, $timeout, dataService) {

		//can change this to change language
		$scope.language = dataService.getLanguage();

		dataService.resetOptions();

		$scope.options = dataService.getOptions();

		$scope.toggle = function(option) {
			dataService.changeOptionState(option.name, !option.active);
		};

		$scope.submit = function() {
			if(dataService.getActiveOptions().length === 0) {
				$scope.errorMessage = "No selections made!"
				$timeout(function() {
					$scope.errorMessage = null;
				}, 2000);
			} else {
				$location.path("/result");
			};
		};
	};
    controllers.appCtrl.$inject = ['$scope', '$location', '$timeout', 'dataService'];

    controllers.resultCtrl = function($scope, $location, $interpolate, $timeout, dataService) {
		
		$scope.displayPage = false;

		$scope.activeOptions = dataService.getActiveOptions();
		if($scope.activeOptions.length === 0) {
			$location.path("/");
		} else {
			$scope.language = dataService.getLanguage();
			var cities = dataService.getCities();

			dataService.getResults($scope.activeOptions).then(function(reply) {
				$scope.result = reply.qHyperCube.qDataPages[0].qMatrix[0][0].qText;
				$scope.city = cities.find(function(obj){return obj.name === $scope.result});
				angular.forEach($scope.activeOptions, function(option) {
					dataService.getOptionData(option, $scope.result).then(function(reply) {
						option.val = Number(Number(reply.val).toFixed(0)).toLocaleString();
						option.avg = Number(Number(reply.avg).toFixed(0)).toLocaleString();
						var optionData = {value: option.val, avg: option.avg, city: $scope.result};
						var valueTextTemplate = $interpolate(option.valueTextTemplate[$scope.language]);
						var avgTextTemplate = $interpolate(option.avgTextTemplate[$scope.language]);
						option.valueText = valueTextTemplate(optionData);
						option.avgText = avgTextTemplate(optionData);
					});
				});
				dataService.getTableData($scope.result).then(function(reply) {
					var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
					var data = [];
					angular.forEach(qMatrix, function(row) {
						if (row[1].qNum !== "NaN") {
							var obj = {
								'name': row[0].qText,
								'val': Number(row[1].qNum.toFixed(0)).toLocaleString(),
								'avg': Number(row[2].qNum.toFixed(0)).toLocaleString()
							};
							data.push(obj);
						}
					});
					$scope.tableData = data;
				});
			}).then(function() { 
				$timeout(function() {
					$scope.displayPage = true;
				}, 1000);
			});
		}
	};
    controllers.resultCtrl.$inject = ['$scope', '$location', '$interpolate', '$timeout', 'dataService'];

    return controllers;
});
